import { Col, Form, Row } from "antd";
import GeneralCompanies from "apps/Common/CompanyTypes/GeneralCompanyTypes";
import GeneralTimePeriodesSelect from "apps/Common/GeneralTimePickerSelect";
import { MazakaSelect } from "apps/Common/MazakaSelect";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetAdvertListFilter } from "../ClientStates";
import MinMaxPrice from "./MinMaxPrice";
import { FC, useEffect } from "react";
import dayjs from "dayjs";
import Address from "./Address";
import { MazakaForm } from "apps/Common/MazakaForm";
import { useSyncUrlFilters } from "../../../../hooks/useSyncUrlFilters";
import { useLocation } from "react-router-dom";



const TopImportantFilters: FC<{ isMobile: boolean }> = ({ isMobile }) => {
  useSyncUrlFilters();
  const eidsOptions = [
    { label: "Eids Onaylı", value: 1 },
    { label: "Eids Onaysız", value: 0 },
  ];
  const dateOptions: Record<
    string,
    { label: string; value: string; OrderDateMin: string; OrderDateMax: string }
  > = {
    Today: {
      label: "Bugün",
      value: "Today",
      OrderDateMin: dayjs().format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    Yesterday: {
      label: "Dün",
      value: "Yesterday",
      OrderDateMin: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    ThisWeek: {
      label: "Bu Hafta",
      value: "ThisWeek",
      OrderDateMin: dayjs().startOf("isoWeek").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastSevenDays: {
      label: "Son 7 Gün",
      value: "LastSevenDays",
      OrderDateMin: dayjs().subtract(7, "day").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastFifteenDays: {
      label: "Son 15 Gün",
      value: "LastFifteenDays",
      OrderDateMin: dayjs().subtract(15, "day").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    ThisMonth: {
      label: "Bu Ay",
      value: "ThisMonth",
      OrderDateMin: dayjs().startOf("month").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastThirtyDays: {
      label: "Son 30 Gün",
      value: "LastThirtyDays",
      OrderDateMin: dayjs().subtract(30, "day").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastMonth: {
      label: "Geçen Ay",
      value: "LastMonth",
      OrderDateMin: dayjs()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD"),
      OrderDateMax: dayjs()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD"),
    },
    ThisYear: {
      label: "Bu Yıl",
      value: "ThisYear",
      OrderDateMin: dayjs().startOf("year").format("YYYY-MM-DD"),
      OrderDateMax: dayjs().format("YYYY-MM-DD"),
    },
    LastYear: {
      label: "Geçen Yıl",
      value: "LastYear",
      OrderDateMin: dayjs()
        .subtract(1, "year")
        .startOf("year")
        .format("YYYY-MM-DD"),
      OrderDateMax: dayjs()
        .subtract(1, "year")
        .endOf("year")
        .format("YYYY-MM-DD"),
    },
    Custom: {
      label: "Özel Tarih Aralığı",
      value: "Custom",
      OrderDateMin: "",
      OrderDateMax: "",
    },
  };
  const [form] = Form.useForm();
  const { filter } = useSelector((state: RootState) => state.realState);
  const dispatch = useDispatch();
  const location = useLocation();

  const locationState = location.state as {
    locationInfo?: {
      type: 'city' | 'district' | 'neighbourhood';
      id: number;
      name: string;
    };
    cityId?: number;
    cityName?: string;
    districtId?: number;
    districtName?: string;
    neighbourhoodId?: number;
    neighbourhoodName?: string;
  };

  const handleEIDS = (value: number, obj: any) => {
    let currentFilter = { ...filter, IsSearchFilter: false };
    if (value || value === 0) {
      currentFilter["EidsApproved"] = Boolean(value);
      currentFilter["eidsTypeName"] = obj["label"];
    } else {
      delete currentFilter["EidsApproved"];
      delete currentFilter["eidsTypeName"];
    }

    dispatch(handleSetAdvertListFilter({ filter: currentFilter }));
  };

  useEffect(() => {
    const startDate = filter?.StartDate ? dayjs(filter?.StartDate) : null;
    const endDate = filter?.EndDate ? dayjs(filter?.EndDate) : null;
    const selectedObjList = filter?.selectedOptionListObj

    const findFromWho = selectedObjList?.find((item: any) => item?.name === "Seçilen Firma Tipi")

    let fromWhoValues = []
    if (findFromWho) {

      fromWhoValues = findFromWho?.values?.map((item: any) => item.key)
    }
    const customDate = [];
    if (startDate) {
      customDate.push(startDate);
    }
    if (endDate) {
      customDate.push(endDate);
    }
    const selectedOption = Object.values(dateOptions).find((option) => {
      return (
        option.OrderDateMin === dayjs(startDate).format("YYYY-MM-DD") &&
        option.OrderDateMax === dayjs(endDate).format("YYYY-MM-DD")
      );
    });

    form.setFieldsValue({
      MinPrice: filter?.MinPrice || null,
      MaxPrice: filter?.MaxPrice || null,
      EidsApproved:
        typeof filter?.EidsApproved === "boolean"
          ? filter?.EidsApproved
            ? 1
            : 0
          : null,
      date: selectedOption
        ? selectedOption.value
        : filter?.StartDate || filter.EndDate
          ? "Custom"
          : undefined,
      customDate: customDate,
      fromWho: fromWhoValues,
      cityId: filter?.CityId,
      districtIds: filter?.DistrictIds,
      neighbourhoodIds: filter?.NeighbourhoodIds,

    });
    if (!filter?.MinPrice) {
      form.resetFields(["MinPrice"]);
    }
    if (!filter?.MaxPrice) {
      form.resetFields(["MaxPrice"]);
    }
  }, [filter]);

  const handleChangeCompanyTypes = (values: string, objList: any) => {
    let currentFilter = { ...filter, IsSearchFilter: false };

    let allOptionObjList = [...(currentFilter?.selectedOptionListObj || [])];

    if (values?.length > 0) {
      const newData = {
        name: "Seçilen Firma Tipi",
        key: objList[0].optionId,
        values: objList?.map((item: any) => ({
          name: item.label,
          key: item.key,
        })),
      };

      const existingIndex = allOptionObjList.findIndex(
        (item) => item.name === "Seçilen Firma Tipi"
      );

      if (existingIndex !== -1) {
        allOptionObjList[existingIndex] = newData;
      } else {
        allOptionObjList.push(newData);
      }
    } else {
      allOptionObjList = allOptionObjList.filter(
        (item) => item.name !== "Seçilen Firma Tipi"
      );
    }

    let optionString = "";
    allOptionObjList.forEach((option) => {
      const optionKey = option.key;
      if (option?.values?.length > 0) {
        option.values.forEach((value: any) => {
          if (optionString) {
            optionString += ",";
          }
          optionString += `${optionKey}:${value?.key || value}`;
        });
      } else {
        if (optionString) {
          optionString += ",";
        }
        optionString += `${option?.key}:${option?.value}`;
      }
    });


    currentFilter["SelectedOptionList"] = optionString;
    currentFilter["selectedOptionListObj"] = allOptionObjList;
    dispatch(handleSetAdvertListFilter({ filter: currentFilter }));
  };


  return (
    <>
  <MazakaForm submitButtonVisible={false} form={form}>
  <Row gutter={[15, 15]}>
    {/* Sol blok (Price, EIDS, Tarih) */}
    <Col xs={24} xl={15}>
      <Row gutter={[15, 15]}>
        {/* Fiyat */}
        <Col xs={24} xl={8}>
          <div className="!bg-white p-2 rounded-md shadow-sm ">
            <MinMaxPrice isMobile={isMobile} className="gap-[15px]" />
          </div>
        </Col>

        {/* EIDS ve Firma Tipi */}
        <Col xs={24} xl={9}>
          <div className="!bg-white p-2 rounded-md shadow-sm ">
            <Row gutter={[10, 10]}>
              <Col xs={24} xl={12}>
                <MazakaSelect
                  className="w-full"
                  options={eidsOptions}
                  allowClear
                  label={isMobile ? "Eids Durumu" : ""}
                  placeholder="Eids Durumu"
                  onChange={handleEIDS}
                  name="EidsApproved"
                />
              </Col>
              <Col xs={24} xl={12}>
                <GeneralCompanies
                  className="w-full"
                  mode="multiple"
                  placeholder="Kimden"
                  label={isMobile ? "Kimden" : ""}
                  name="fromWho"
                  onChange={handleChangeCompanyTypes}
                />
              </Col>
            </Row>
          </div>
        </Col>

        {/* Tarih */}
        <Col xs={24} xl={7}>
          <div className="!bg-white p-2 rounded-md shadow-sm ">
            <GeneralTimePeriodesSelect
              isMobile={isMobile}
              filter={filter}
              dateOptions={dateOptions}
              actionFunc={handleSetAdvertListFilter}
              form={form}
            />
          </div>
        </Col>
      </Row>
    </Col>

    {/* Sağ blok (Adres) */}
    <Col xs={24} xl={9}>
      <div className="!bg-white p-2 rounded-md shadow-sm ">
        <Row gutter={[16, 16]}>
          <Address
            form={form}
            isMobile={isMobile}
            {...(locationState?.locationInfo
              ? {
                  ...locationState.locationInfo,
                  cityId: locationState.cityId,
                  cityName: locationState.cityName,
                  districtId: locationState.districtId,
                  districtName: locationState.districtName,
                  neighbourhoodId: locationState.neighbourhoodId,
                  neighbourhoodName: locationState.neighbourhoodName,
                }
              : {})}
          />
        </Row>
      </div>
    </Col>
  </Row>
</MazakaForm>

    </>
  );
};

export default TopImportantFilters;
